import React from 'react';

const Eye = ({ on = true }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="eye"
      x="0px"
      y="0px"
      width="30px"
      height="25px"
      viewBox="0 0 30 25"
      style={{
        enableBackground: 'new 0 0 561 561',
        width: '100%',
        height: '100%'
      }}
      xmlSpace="preserve"
    >
      <g id="Mobile-II" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="toast_03" transform="translate(-757.000000, -419.000000)">
          <g id="eye_off" transform="translate(750.000000, 410.000000)">
            <g id="eye-copy">
              <rect id="Rectangle-2" x="0" y="0" width="44" height="44" />
              <path
                d="M22.012,13 C25.8342678,13 29.0827885,14.6262853 31.7501055,17.3106491 C32.6729907,18.2394324 33.4600408,19.2320826 34.1149817,20.2258786 C34.5115483,20.8276217 34.7793555,21.3029427 34.9203797,21.5897408 L35.1373413,22.0309711 L34.9204026,22.4722126 C34.7801544,22.7574698 34.5136764,23.2297852 34.1186176,23.8275302 C33.4663444,24.8144544 32.6813898,25.800178 31.7596815,26.722407 C29.0970972,29.3864956 25.8458931,31 22.012,31 C17.8090149,31 14.4635692,29.3760465 11.9270648,26.6860438 C11.0441659,25.7497158 10.3237639,24.7484794 9.75154238,23.7455718 C9.40407601,23.1365826 9.17994335,22.6537146 9.06657924,22.3587836 L8.90676844,21.9430157 L9.10893925,21.5461159 C9.25393678,21.2614582 9.52806324,20.7890227 9.93178161,20.1906814 C10.5987289,19.2022147 11.3955506,18.2148425 12.324438,17.2909786 C15.0108249,14.61912 18.2451182,13 22.012,13 Z M22.03,26 C24.345573,26 26.03,24.2942151 26.03,22 C26.03,19.7051678 24.3459481,18 22.03,18 C19.7140519,18 18.03,19.7051678 18.03,22 C18.03,24.2942151 19.714427,26 22.03,26 Z M22.0281906,18.0000016 C24.2242716,17.996028 26.03,19.8237978 26.03,22 C26.03,24.1728967 24.22493,26 22.03,26 C19.8347843,26 18.03,24.1736015 18.03,22 C18.03,19.8268837 19.8329785,18.0039737 22.0281906,18.0000016 Z"
                id="Shape"
                fillRule="nonzero"
                style={{ stroke: 'currentcolor', strokeWidth: '2px' }}
              />
            </g>
            {on && (
              <g>
                <rect
                  id="Rectangle-5"
                  fill="#FFFFFF"
                  transform="translate(21.886932, 21.447592) rotate(-45.000000) translate(-21.886932, -21.447592) "
                  x="20.0762716"
                  y="6.44759198"
                  width="3.62132034"
                  height="30"
                />
                <rect
                  id="Rectangle-5-Copy"
                  transform="translate(20.869165, 21.947592) rotate(-45.000000) translate(-20.869165, -21.947592) "
                  x="19.8691649"
                  y="6.94759198"
                  width="2"
                  height="30"
                  style={{ fill: 'currentcolor' }}
                />
              </g>
            )}
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Eye;
